<template>
    <div class="">
        <div class="" style="display: block" v-if="isaAdminPageOpened()">
            <div class="reports_container d-flex flex-column">
                <h2 class="dark-title size-16 my-5">{{ $t('res_Label_AdminPages') }}</h2>
                <div class="grid-4-items">
                    <v-card @click="openOrganizationManagementPage()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_OrganizationManagement') }}</h4>
                        <p>{{ $t('res_Label_OrganizationManagementDesc') }} </p>
                    </v-card>
                    <v-card @click="openManageUsersPage()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_UserManagement') }}</h4>
                        <p> {{ $t('res_Label_UserManagementDesc') }} </p>
                    </v-card>
                    <v-card @click="openSystemDelegationPage()" v-if="(this.defaultApplicationId == 1)">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_SystemDelegation') }} </h4>
                        <p>{{ $t('res_Label_SystemDelegationDesc') }} </p>
                    </v-card>
                    <v-card @click="openManageCorrespondencesPage()" v-if="defaultApplicationId == 1">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_CorrespondenceManagement') }} </h4>
                        <p>{{ $t('res_Label_CorrespondenceManagementDesc') }} </p>
                    </v-card>
                    <v-card @click="openManageExternalEntitiesPage()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_ManageExternalEntities') }} </h4>
                        <p>{{ $t('res_Label_ManageExternalsDesc') }} </p>
                    </v-card>
                    <v-card v-if="defaultApplicationId == 1" @click="openMoveCorrespondences()">
                        <h4 class="dark-title size-16 pb-2">
                            {{ $t("res_Label_MoveCorrespondences") }}
                        </h4>
                        <p>{{ $t("res_Label_MoveCorrespondencesToStructureOrUser") }}</p>
                    </v-card>
                    <!-- <v-card v-if="constants.isFullAdmin" @click="openManageMoveUser()">
                        <div class="d-flex flex-column justify-space-between" style="height: 100%;">
                            <div>
                                <h4 class="dark-title size-16 pb-2">{{ $t("res_Label_ManageMoveUser") }}</h4>
                                <p>{{ $t("res_Label_ManageMoveUserFormat") }}</p>
                            </div>
                            <icon-tooltip icon="mdi-incognito" :text="$t('res_Tooltip_IncognitoIcon')"></icon-tooltip>
                        </div>
                    </v-card> -->
                    <!-- <v-card v-if="constants.isFullAdmin" @click="openManageMoveStructure()">
                        <div class="d-flex flex-column justify-space-between" style="height: 100%;">
                            <div>
                                <h4 class="dark-title size-16 pb-2">{{ $t("res_Label_ManageMoveStructure") }}</h4>
                                <p>{{ $t("res_Label_ManageMoveStructureFormat") }}</p></div>
                            <icon-tooltip icon="mdi-incognito" :text="$t('res_Tooltip_IncognitoIcon')"></icon-tooltip>
                        </div>
                    </v-card> -->
                    <v-card v-if="constants.isFullAdmin" @click="openManageRolesPage()">
                        <div class="d-flex flex-column justify-space-between" style="height: 100%;">
                            <div>
                                <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_ManageRoles') }} </h4>
                                <p>{{ $t('res_Label_ManageRolesDesc') }} </p>
                            </div>
                            <icon-tooltip icon="mdi-incognito" :text="$t('res_Tooltip_IncognitoIcon')"></icon-tooltip>
                        </div>
                    </v-card>
                    <v-card v-if="constants.isFullAdmin" @click="openManageActionsPage()">
                        <div class="d-flex flex-column justify-space-between" style="height: 100%;">
                            <div>
                                <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_ManageActions') }} </h4>
                                <p>{{ $t('res_Label_ManageActionsDesc') }} </p>
                            </div>
                            <icon-tooltip icon="mdi-incognito" :text="$t('res_Tooltip_IncognitoIcon')"></icon-tooltip>
                        </div>
                    </v-card>
                    <v-card v-if="constants.isFullAdmin && defaultApplicationId == 1" @click="openManageReferenceFormatPage()">
                        <div class="d-flex flex-column justify-space-between" style="height: 100%;">
                            <div>
                                <h4 class="dark-title size-16 pb-2">{{ $t('res_Title_ManageReference') }} </h4>
                                <p>{{ $t('res_Label_ManageReferenceFormat') }} </p>
                            </div>
                            <icon-tooltip icon="mdi-incognito" :text="$t('res_Tooltip_IncognitoIcon')"></icon-tooltip>
                         </div>
                    </v-card>
                    <v-card v-if="constants.isFullAdmin && this.defaultApplicationId == 1" @click="openManageCounterReferenceFormatPage()">
                        <div class="d-flex flex-column justify-space-between" style="height: 100%;">
                            <div>
                                <h4 class="dark-title size-16 pb-2">{{ $t('res_Title_ManageCounter') }} </h4>
                                <p>{{ $t('res_Label_ManageCounterFormat') }} </p>
                            </div>
                            <icon-tooltip icon="mdi-incognito" :text="$t('res_Tooltip_IncognitoIcon')"></icon-tooltip>
                         </div>
                    </v-card>
                    <v-card v-if="constants.isFullAdmin && this.defaultApplicationId == 1" @click="openManageSystemLookups()">
                        <div class="d-flex flex-column justify-space-between" style="height: 100%;">
                            <div>
                                <h4 class="dark-title size-16 pb-2">{{ $t('res_Title_ManageDocumentLookups') }} </h4>
                                <p>{{ $t('res_label_ManageDocumentLookups') }} </p>
                            </div>
                            <icon-tooltip icon="mdi-incognito" :text="$t('res_Tooltip_IncognitoIcon')"></icon-tooltip>
                         </div>
                    </v-card>
                    <!-- <v-card v-if="constants.isFullAdmin && showManageGroup" @click="openManageCommittees()">
                        <div class="d-flex flex-column justify-space-between" style="height: 100%;">
                            <div>
                                <h4 class="dark-title size-16 pb-2">{{ $t("res_Label_ManageEntityGroup") }}</h4>
                                <p>{{ $t("res_Label_ManageEntityGroup") }}</p>
                            </div>
                            <icon-tooltip icon="mdi-incognito" :text="$t('res_Tooltip_IncognitoIcon')"></icon-tooltip>
                        </div>
                    </v-card> -->
                    <v-card v-if="constants.isFullAdmin" @click="openManagePublicAnnouncementsPage()">
                        <div class="d-flex flex-column justify-space-between" style="height: 100%;">
                            <div>
                                <h4 class="dark-title size-16 pb-2">{{ $t("res_Label_ManagePublicAnnouncements") }}</h4>
                                <p>{{ $t("res_Label_ManagePublicAnnouncementsFormat") }}</p>
                            </div>
                            <icon-tooltip icon="mdi-incognito" :text="$t('res_Tooltip_IncognitoIcon')"></icon-tooltip>
                        </div>
                    </v-card>
                    <v-card v-if="constants.isFullAdmin" @click="openAuditTrailPage()">
                        <div class="d-flex flex-column justify-space-between" style="height: 100%;">
                            <div>
                                <h4 class="dark-title size-16 pb-2">{{ $t("res_Label_AuditTrail") }}</h4>
                                <p>{{ $t("res_Label_AuditTrailFormat") }}</p>
                            </div>
                            <icon-tooltip icon="mdi-incognito" :text="$t('res_Tooltip_IncognitoIcon')"></icon-tooltip>
                        </div>
                    </v-card>
                    <v-card v-if="false" @click="openAttachmentManagement()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_ManageAttachments') }} </h4>
                        <p>{{ $t('res_Label_ManageAttachmentsDesc') }} </p>
                    </v-card>
                    
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    import router from '../../router/index.js'
    import constants from '../../assets/js/constants'
    import MessagesUtil from '@/utils/messagesUtil'
    import IconTooltip from '@/components/IconTooltip.vue'

    export default {
        name: 'Main',
        components: {
            IconTooltip
        },
        data: function () {
            return {
                messagesUtil: MessagesUtil,
                constants: constants,
                defaultApplicationId: 1,
                showBetaFeatures: false,
                enableCommitteesChairmanUsers: false,
                showManageGroup: false
            };
        },
        mounted() 
        {
            document.body.classList.add('hide-searchbar');
            this.defaultApplicationId = constants.defaultApplicationId
            this.showBetaFeatures = window.showBetaFeatures
            this.showManageGroup = window.showManageGroup
            this.enableCommitteesChairmanUsers = window.enableCommitteesChairmanUsers
        },
        async beforeDestroy() {
            document.body.classList.remove('hide-searchbar');
        },
        methods:
        {
            isaAdminPageOpened() {
                return this.$route.name === 'admin'
            },
            openTemplateTagsPage() {
                router.push({ name: 'templateTags' })
            },
            openOrganizationManagementPage() {
                router.push({ name: 'organization' })
            },
            openManageUsersPage() {
                router.push({ name: 'manageUsers' })
            },
            openSystemDelegationPage() {
                router.push({ name: 'systemDelegation' })
            },
            openManageCorrespondencesPage() {
                router.push({ name: 'manageCorrespondences' })
            },
            openMoveCorrespondences() {
                router.push({ name: "MoveCorrespondences" });
            },
            openManageDispatchEntitiesPage() {
                router.push({ name: 'manageDispatchEntities' })
            },
            openManageExternalEntitiesPage() {
                router.push({ name: 'manageExternalEntities' })
            },
            openManageRolesPage() {
                router.push({ name: 'manageRoles' })
            },
            openManageActionsPage() {
                router.push({ name: 'actions' })
            },
            openManageReferenceFormatPage() {
                router.push({ name: 'manageRefernceFormat' })
            },
            openManageCounterReferenceFormatPage() {
                router.push({ name: 'manageCounter' })
            },
            openManageSystemLookups(){
                router.push({ name: 'manageSystemLookups' })
            },
            openManageCommittees() {
            router.push({ name: "ManageCommittees" });
            },
            openManageMoveUser() {
                router.push({ name: "ManageMoveUser" });
            },
            openManageMoveStructure() {
                router.push({ name: "ManageMoveStructure" });
            }, 
            openManagePublicAnnouncementsPage() {
                router.push({ name: 'ManagePublicAnnouncements' })
            },
            openAuditTrailPage() {
                router.push({ name: 'AuditTrails' })
            },
            openAttachmentManagement(){
                router.push({ name: "AttachmentVersions" });
            }
        }
    }
</script>

